import type { ReactNode } from "react";
import { Button } from "@swot/base-components";

export type SwotKpiCardProps = {
  readonly label: string;
  readonly value: ReactNode;
  readonly description?: ReactNode | undefined;
  readonly trend?: ReactNode | undefined;
  readonly loading?: boolean | undefined;
  readonly disabled?: boolean | undefined;
  readonly onClick?: (() => void) | undefined;
};

export function SwotKpiCard(props: SwotKpiCardProps) {
  const content = (
    <>
      <span className="swot-kpi-card__label">{props.label}</span>
      <strong className="swot-kpi-card__value">{props.loading ? "Loading" : props.value}</strong>
      {props.trend ? <span className="swot-kpi-card__trend">{props.trend}</span> : null}
      {props.description ? <small className="swot-kpi-card__description">{props.description}</small> : null}
    </>
  );
  if (props.onClick) {
    return <Button className="swot-kpi-card" variant="ghost" disabled={props.disabled || props.loading} loading={Boolean(props.loading)} onClick={props.onClick} aria-label={`${props.label}: ${String(props.value)}`}>{content}</Button>;
  }
  return <article className="swot-kpi-card" aria-busy={props.loading ? "true" : undefined}>{content}</article>;
}
